<!-- components/staff/resetStaffPwd.vue -->
<template>
  <el-dialog :title="$t('staff.confirmOperation')" :visible.sync="visible" width="30%" @close="handleClose">
    <el-form ref="pwdForm" :model="form" :rules="rules" label-width="100px">
      <el-form-item :label="$t('staff.newPassword')" prop="pwd">
        <el-input v-model="form.pwd" type="password" show-password
                  :placeholder="$t('staff.pwdPlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('staff.confirmPassword')" prop="confirmPwd">
        <el-input v-model="form.confirmPwd" type="password" show-password
                  :placeholder="$t('staff.confirmPwdPlaceholder')" />
      </el-form-item>
      <div class="tips" style="color:#909399;font-size:12px;line-height:1.4;">
        {{ $t('staff.pwdRule') }}
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('staff.wrongClick') }}</el-button>
      <el-button type="primary" :loading="loading" @click="resetStaffPwd">{{ $t('staff.confirmReset') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { resetStaffPwd } from '@/api/staff/staffApi'

// 密码规则：必须同时包含大写字母、小写字母、数字及常用特殊字符，长度不低于8位
const PWD_REG = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*()_+\\-=\\[\\]{}|;:',.<>?/])[A-Za-z\\d!@#$%^&*()_+\\-=\\[\\]{}|;:',.<>?/]{8,}$")

export default {
  name: 'ResetStaffPwd',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    staffInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const validatePwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('staff.pwdRequired')))
      }
      if (!PWD_REG.test(value)) {
        return callback(new Error(this.$t('staff.pwdRule')))
      }
      // 新密码变更后，若确认密码已填写则重新校验一致性
      if (this.form.confirmPwd) {
        this.$refs.pwdForm.validateField('confirmPwd')
      }
      callback()
    }
    const validateConfirm = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('staff.confirmPwdRequired')))
      }
      if (value !== this.form.pwd) {
        return callback(new Error(this.$t('staff.pwdNotMatch')))
      }
      callback()
    }
    return {
      loading: false,
      form: {
        pwd: '',
        confirmPwd: ''
      },
      rules: {
        pwd: [{ validator: validatePwd, trigger: 'blur' }],
        confirmPwd: [{ validator: validateConfirm, trigger: 'blur' }]
      }
    }
  },
  watch: {
    // 通过 :visible.sync 方式打开时也清空上一次的输入
    visible(val) {
      if (val) {
        this.resetForm()
      }
    }
  },
  methods: {
    open(row) {
      this.visible = true
      this.staffInfo = { ...row }
      this.resetForm()
    },    resetForm() {
      this.form.pwd = ''
      this.form.confirmPwd = ''
      this.$nextTick(() => {
        if (this.$refs.pwdForm) {
          this.$refs.pwdForm.clearValidate()
        }
      })
    },
    handleClose() {
      this.visible = false
      this.$emit('update:visible', false)
      this.resetForm()
    },
    resetStaffPwd() {
      this.$refs.pwdForm.validate(async valid => {
        if (!valid) {
          return
        }
        try {
          this.loading = true
          const data = {
            communityId: '-1',
            staffId: this.staffInfo.userId,
            pwd: this.form.pwd
          }

          await resetStaffPwd(data)
          this.$message.success(this.$t('staff.resetSuccess'))
          this.$emit('success')
          this.handleClose()
        } catch (error) {
          this.$message.error(error.message)
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>
